import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { useChangeExamStatus } from "src/hooks/useExam";
import { useCreateExam } from "src/hooks/useExams";
import CopyExamIcon from "src/images/Icons/newIcons/copy.svg";
import GenerateExamIcon from "src/images/Icons/newIcons/fileClose.svg";
import ResumeExamIcon from "src/images/Icons/newIcons/resume.svg";
import { ExamStatus } from "src/types/enums";

import DefaultActions from "./DefaultActions";

export default function LessonActions({ row, additionalActions = [] }) {
	const isAllResolved = row.totalQuestions === row.resolvedQuestions;
	const { mutateAsync: patchExam } = useChangeExamStatus();
	const { closeAllModals } = useModals();
	const history = useHistory();
	const { t } = useTranslation();
	const { mutateAsync: generateExam } = useCreateExam();
	const isFinishedExam = row.status === ExamStatus.FINISHED;

	const generateExamFromWrongAnswers = async () => {
		closeAllModals();
		await generateExam({
			finishedExamsIds: [{ id: row.id }],
			additionalOption: {
				wrongAnswers: true,
			},
			name: `${t("defaultNames.wrongAnswers")} - ${row.name}`,
		});
	};

	const resumeExam = async () => {
		await patchExam({ id: row.id, status: "unfinished" });
		closeAllModals();
		return history.push(generatePath(routing.paths.exam, { id: row.id }));
	};

	const copyExam = async () => {
		closeAllModals();
		await generateExam({
			examsIds: [{ id: row.id }],
			name: row.name,
		});
	};

	const defaultItems = [
		!isAllResolved &&
			isFinishedExam && {
				title: t("menuActions.exams.resume"),
				onClick: () => resumeExam(),
				Icon: <ResumeExamIcon className="icon-small" />,
			},
		isFinishedExam && {
			title: t("menuActions.exams.copyExam"),
			onClick: () => copyExam(),
			Icon: <CopyExamIcon className="icon-small" />,
		},
		!!row.wrongAnswers && {
			title: t("menuActions.lessons.generateExamFromWrongAnswers"),
			onClick: () => generateExamFromWrongAnswers(),
			Icon: <GenerateExamIcon className="icon-small" />,
		},
		...additionalActions,
	];

	return <DefaultActions row={row} defaultItems={defaultItems} />;
}
